import React, { useState } from "react";
import { AppleIcon, Eyecloseicon } from "../assest/SvgImages";
import Inputbox from "../Components/Inputbox";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { userLoginProcess } from "../../helpers/helper";
import { Store } from "../../redux";
import { Box, Modal } from "@mui/material";
import { setLoginType } from "../../redux/cookiesReducer";
import { ShowToast } from "../../helpers/ToastService";

const LoginScreen = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const [showloagout, setshowloagout] = useState(false);
  const [chooserole, setchooserole] = useState(false);
  const [password, setPassword] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
 const fromPath = location.state?.from;
  const step = location.state?.step;
const onSubmit = (formData) => {
  if (!selectedRole) {
    return ShowToast("Please Select Role", "info");
  }
 


userLoginProcess(formData, (userRole) => {
  if (fromPath) {
    navigate(fromPath, {
      state: { step: step } 
    });
  } else {
    switch (userRole) {
      case "agency":
        navigate("/dashboradScreen");
        break;
      case "doctor":
        navigate("/dashboard");
        break;
      case "patient":
        navigate("/Dashboradpatient");
        break;
      default:
        navigate("/login");
    }
  }
});

};


  const handelEye = () => {
    setPassword(!password);
  };
  const handleClose = () => {
    setshowloagout(false);
  };
  const handleClosechooserole = () => {
    setchooserole(false);
  };
  const [selectedRole, setSelectedRole] = useState(null);
  const [type, setType] = useState(false);

  const handleRoleSelect = (role) => {
    setSelectedRole(role);
  };
  const handleLoginRoleSelect = (role) => {
    setSelectedRole(role);
    Store.dispatch(setLoginType(role));
    setchooserole(false);
  };
  const navigate = useNavigate();

  const handleNext = () => {
    if (selectedRole === "Patient") {
      navigate("/signupPatient");
    } else if (selectedRole === "Doctor") {
      navigate("/signup");
    } else if (selectedRole === "Clinic") {
      navigate("/agencyRegistration");
      // navigate('/signup');
    }
  };

  const loginSelect = () => {
    // Store.dispatch(setLoginType(selectedRole))
    navigate("/login");
  };

  return (
    <div className="login-container">
      <div className="left-panel">
        <img
          src={require("../assest/Images/mindwellnewlogo.png")}
          alt="Mindwell Logo"
          className="logo"
        />
        <div className="slogan">
          Your trusted platform for mental health services.
        </div>
      </div>
      <div className="right-panel">
        <h2 className="welcome-text">Welcome back!</h2>
        <form onSubmit={handleSubmit(onSubmit)} className="login-form">
          <label className="email-label">Choose Role</label>
          <div
            onClick={() => setchooserole(true)}
            className="role-selector_login"
          >
            {!selectedRole ? (
              <span className="placeholder">Choose Role</span>
            ) : (
              selectedRole
            )}
          </div>
          <div className="input-container">
            <label className="email-label">Email / Unique ID</label>
            <input
              type="text"
              placeholder="Enter Email"
              {...register("email", { required: true })}
              className="input-field"
            />
            {errors.email && (
              <div className="errorMessage">Email / Unique ID is required</div>
            )}
          </div>
          <div className="input-container">
            <label className="email-label">Password</label>
            <div className="password-container">
              <input
                type={password ? "text" : "password"}
                placeholder="Enter Password"
                {...register("password", { required: true })}
                className="input-field"
              />
              <span
                className={
                  errors.password ? "password-icon-two" : "password-icon"
                }
                onClick={handelEye}
              >
                <Eyecloseicon />
              </span>
            </div>
            {errors.password && (
              <div className="errorMessage">Password is required</div>
            )}
            <Link to="/forget" className="forgot-password">
              Forgot Password?
            </Link>
          </div>
          <input className="login-button" type="submit" value="Next" />
        </form>

        <div className="or-login-with">
          <p>Or Login with</p>
          <div className="social-icons">
            <div className="apple-logo-div">
              <AppleIcon />
            </div>
            <div className="apple-logo-div">
              <img
                src={require("../assest/Images/FacbookIcon.png")}
                alt="Facebook"
                className="social-icon"
              />
            </div>
            <div className="apple-logo-div">
              <img
                src={require("../assest/Images/GoogleIcon.png")}
                alt="Google"
                className="social-icon"
              />
            </div>
          </div>
        </div>
        <div className="dont-have-account">
          Don’t have an Account?
          <div className="register-txt" onClick={() => setshowloagout(true)}>
            Register
          </div>
        </div>
      </div>

      <Modal
        open={showloagout}
        onClose={handleClose}
    
      >
        <Box sx={style}>
          <div className="login-box">
            <div className="close-button_login" onClick={handleClose}>
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqgtxjCOy_ZhfNNQG0c_OWnEsAzq8x7f3NLA&s"
                alt="Close"
                className="close-icon_login"
              />
            </div>
            <h4 className="modal-title_login">
              Sign up as Patient, Doctor or Clinic
            </h4>
            <div
              className={`login-option ${
                selectedRole === "Clinic" ? "selected" : ""
              }`}
              onClick={() => handleRoleSelect("Clinic")}
            >
              <img
                src={require("../assest/Images/hospitalimg.png")}
                alt="Hospital Image"
                className="role-icon"
              />
              <span>Clinic / Agency</span>
              <input
                type="checkbox"
                checked={selectedRole === "Clinic"}
                readOnly
              />
            </div>
            <div
              className={`login-option ${
                selectedRole === "Doctor" ? "selected" : ""
              }`}
              onClick={() => handleRoleSelect("Doctor")}
            >
              <img
                src={require("../assest/Images/doctorimg.png")}
                alt="Doctor"
                className="role-icon"
              />
              <span>Doctor</span>
              <input
                type="checkbox"
                checked={selectedRole === "Doctor"}
                readOnly
              />
            </div>
            <div
              className={`login-option ${
                selectedRole === "Patient" ? "selected" : ""
              }`}
              onClick={() => handleRoleSelect("Patient")}
            >
              <img
                src={require("../assest/Images/Patientimg.png")}
                alt="Patient"
                className="role-icon"
              />
              <span>Patient</span>
              <input
                type="checkbox"
                checked={selectedRole === "Patient"}
                readOnly
              />
            </div>
            <button
              className="login-button"
              onClick={type ? loginSelect : handleNext}
            >
              Next
            </button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={chooserole}
        onClose={handleClosechooserole}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="login-box">
            <h4 className="modal-title_login">
              Login as Patient, Doctor or Clinic
            </h4>
            <div
              className={`login-option ${
                selectedRole === "Clinic" ? "selected" : ""
              }`}
              onClick={() => handleLoginRoleSelect("Clinic")}
            >
              <img
                src={require("../assest/Images/hospitalimg.png")}
                alt="Hospital Image"
                className="role-icon"
              />
              <span>Clinic / Agency</span>
              <input
                type="checkbox"
                checked={selectedRole === "Clinic"}
                readOnly
              />
            </div>
            <div
              className={`login-option ${
                selectedRole === "Doctor" ? "selected" : ""
              }`}
              onClick={() => handleLoginRoleSelect("Doctor")}
            >
              <img
                src={require("../assest/Images/doctorimg.png")}
                alt="Doctor"
                className="role-icon"
              />
              <span>Doctor</span>
              <input
                type="checkbox"
                checked={selectedRole === "Doctor"}
                readOnly
              />
            </div>
            <div
              className={`login-option ${
                selectedRole === "Patient" ? "selected" : ""
              }`}
              onClick={() => handleLoginRoleSelect("Patient")}
            >
              <img
                src={require("../assest/Images/Patientimg.png")}
                alt="Patient"
                className="role-icon"
              />
              <span>Patient</span>
              <input
                type="checkbox"
                checked={selectedRole === "Patient"}
                readOnly
              />
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default LoginScreen;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};
